'use client'
import { ReclameAquiBadge } from '@/components/atoms/reclame-aqui-badge'
import { Separator } from '@/components/atoms/separator'
import { TreeunfeLogo } from '@/components/atoms/treeunfe-logo'
import Link from 'next/link'
import { footerMenuMock } from './mock'

export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="w-full min-h-[780px] bg-gray-100 px-4 xl:px-0">
      <section className="max-w-[1260px] mx-auto">
        <section className="gap-y-4 flex">
          <nav className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 grid-rows-2 gap-x-36 gap-y-12 mt-28">
            {footerMenuMock?.map((menu) => (
              <div key={menu.id}>
                <span className="text-md font-medium">{menu.title}</span>
                <ul className="flex flex-col mt-2 space-y-2 h-auto">
                  {menu?.links?.map((link) => (
                    <li key={link.id}>
                      {link.isDisabled ? (
                        <button
                          type="button"
                          className="!w-auto !min-h-auto cursor-not-allowed text-sm font-normal flex gap-2 text-gray-500"
                          disabled
                          aria-label={`${link.title} disabled link`}
                        >
                          {link.title}
                          <span className="bg-[#01634F] rounded-full px-2 text-[8px] text-white">
                            Em breve
                          </span>
                        </button>
                      ) : link.function ? (
                        <p
                          className="!w-auto cursor-pointer hover:text-[#01634F] !min-h-auto text-sm font-normal flex gap-2"
                          onClick={link.function}
                        >
                          {link.title}
                        </p>
                      ) : (
                        <Link
                          href={link.href}
                          target={link.target}
                          className="!w-auto cursor-pointer hover:text-[#01634F] !min-h-auto text-sm font-normal flex gap-2"
                          aria-label={`${link.title} link`}
                        >
                          {link.title}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </section>
        <Separator className="mt-11 mb-9 bg-[#D7D7D7]" />
        <section className="flex flex-col items-center space-y-8 lg:flex-row lg:justify-between lg:items-end">
          <div className="flex flex-col space-y-6 lg:space-y-0  lg:items-start lg:gap-y-8 items-center  justify-center gap-x-8  ">
            <TreeunfeLogo href="/" />
            <address className="text-sm font-sans not-italic font-medium text-gray-500 max-w-[320px] xl:text-nowrap lg:text-start text-center lg:max-w-none">
              Avenida Business Center - Andar 04
              <br />
              Av. Advogado Horácio Raccanello Filho, 5145
              <br />
              Zona 7, Maringá - PR, 87020-035
              <br />
              CNPJ: 23.903.417/0001-60
              <br />
              <br />
              2016 • {currentYear} © Treeunfe Inteligência Fiscal
            </address>
          </div>

          <div className="flex flex-col pb-8 lg:pb-0  lg:items-end lg:justify-end gap-y-8 gap-x-8 ">
            <div className="flex mt-6 lg:mt-0 justify-center items-center gap-x-4">
              <Link
                href="https://www.instagram.com/treeunfe/"
                aria-label="Instagram link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.66537 0.280273C2.0927 0.280273 0 2.37491 0 4.94824V11.6149C0 14.1876 2.09463 16.2803 4.66797 16.2803H11.3346C13.9073 16.2803 16 14.1856 16 11.6123V4.94564C16 2.37297 13.9054 0.280273 11.332 0.280273H4.66537ZM12.6667 2.94694C13.0347 2.94694 13.3333 3.24561 13.3333 3.61361C13.3333 3.98161 13.0347 4.28027 12.6667 4.28027C12.2987 4.28027 12 3.98161 12 3.61361C12 3.24561 12.2987 2.94694 12.6667 2.94694ZM8 4.28027C10.206 4.28027 12 6.07427 12 8.28027C12 10.4863 10.206 12.2803 8 12.2803C5.794 12.2803 4 10.4863 4 8.28027C4 6.07427 5.794 4.28027 8 4.28027ZM8 5.61361C6.52724 5.61361 5.33333 6.80751 5.33333 8.28027C5.33333 9.75303 6.52724 10.9469 8 10.9469C9.47276 10.9469 10.6667 9.75303 10.6667 8.28027C10.6667 6.80751 9.47276 5.61361 8 5.61361Z"
                    fill="#0C111D"
                  />
                </svg>
              </Link>
              <Link
                href="https://www.facebook.com/treeunfe"
                aria-label="Facebook link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="30"
                  viewBox="0 0 50 50"
                >
                  <path
                    d="M41,4H9C6.24,4,4,6.24,4,9v32c0,2.76,2.24,5,5,5h32c2.76,0,5-2.24,5-5V9C46,6.24,43.76,4,41,4z M37,19h-2c-2.14,0-3,0.5-3,2 v3h5l-1,5h-4v15h-5V29h-4v-5h4v-3c0-4,2-7,6-7c2.9,0,4,1,4,1V19z"
                    fill="#0C111D"
                  ></path>
                </svg>
              </Link>
              <Link
                href="https://www.youtube.com/@Treeunfe"
                aria-label="Youtube Link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="30"
                  viewBox="0 0 50 50"
                >
                  <path
                    d="M 44.898438 14.5 C 44.5 12.300781 42.601563 10.699219 40.398438 10.199219 C 37.101563 9.5 31 9 24.398438 9 C 17.800781 9 11.601563 9.5 8.300781 10.199219 C 6.101563 10.699219 4.199219 12.199219 3.800781 14.5 C 3.398438 17 3 20.5 3 25 C 3 29.5 3.398438 33 3.898438 35.5 C 4.300781 37.699219 6.199219 39.300781 8.398438 39.800781 C 11.898438 40.5 17.898438 41 24.5 41 C 31.101563 41 37.101563 40.5 40.601563 39.800781 C 42.800781 39.300781 44.699219 37.800781 45.101563 35.5 C 45.5 33 46 29.398438 46.101563 25 C 45.898438 20.5 45.398438 17 44.898438 14.5 Z M 19 32 L 19 18 L 31.199219 25 Z"
                    fill="#0C111D"
                  ></path>
                </svg>
              </Link>
              <Link
                href="https://www.linkedin.com/company/treeunfe"
                aria-label="Linkedin link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.1513 0.515625H2.31932C1.29882 0.515625 0.470581 1.34386 0.470581 2.36436V14.1963C0.470581 15.2168 1.29882 16.045 2.31932 16.045H14.1513C15.1718 16.045 16 15.2168 16 14.1963V2.36436C16 1.34386 15.1718 0.515625 14.1513 0.515625ZM5.2773 6.43159V13.4568H3.05882V6.43159H5.2773ZM3.05882 4.38689C3.05882 3.86924 3.50251 3.47361 4.16806 3.47361C4.83361 3.47361 5.25142 3.86924 5.2773 4.38689C5.2773 4.90453 4.86319 5.32235 4.16806 5.32235C3.50251 5.32235 3.05882 4.90453 3.05882 4.38689ZM13.4118 13.4568H11.1933C11.1933 13.4568 11.1933 10.0329 11.1933 9.75932C11.1933 9.01983 10.8235 8.28033 9.89915 8.26554H9.86957C8.97478 8.26554 8.60503 9.02722 8.60503 9.75932C8.60503 10.0958 8.60503 13.4568 8.60503 13.4568H6.38655V6.43159H8.60503V7.37815C8.60503 7.37815 9.31865 6.43159 10.7533 6.43159C12.2212 6.43159 13.4118 7.441 13.4118 9.48571V13.4568Z"
                    fill="#0C111D"
                  />
                </svg>
              </Link>
            </div>
            <ReclameAquiBadge />
          </div>
        </section>
      </section>
    </footer>
  )
}
